import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { createAddressAction } from "../action/createAddressAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const createAddressSlice = createSlice({
  name: "createAddressSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAddressAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAddressAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createAddressAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createAddressReducer = createAddressSlice.reducer;
